import React from 'react';
import { Modal, Image as BootstrapImage, Dropdown } from 'react-bootstrap';
import { Buffer } from 'buffer';

import { ToolBar, ToolBarGroup } from 'src/legacy/components/ToolBar/ToolBar.jsx';
import { ToolBarButtonItem } from 'src/legacy/components/ToolBar/ToolBarButtonItem.jsx';
import PositionView from './position';

import isEqual from 'is-equal';
import cx from 'classnames';
import Button from 'src/components/button';
import styles from './styles.module.scss';

import CropImageView from './crop';
import ImageLibraryContainer from "./library";
import SharedByView from './sharedBy';

import noFilterIcon from 'src/legacy/images/noFilter.png';
import darkFilter from 'src/legacy/images/darkFilter.png';
import lightFilter from 'src/legacy/images/lightFilter.png';
import dots from 'src/legacy/images/dots.svg';
import stripes from 'src/legacy/images/stripes.svg';
import lines from 'src/legacy/images/lines.svg';
import gradientTop from 'src/legacy/images/gradientTop.svg';
import gradientBottom from 'src/legacy/images/gradientBottom.svg';
import darkOverlay from 'src/legacy/images/collections/darkOverlay.png';
import whiteOverlay from 'src/legacy/images/collections/whiteOverlay.png';


import BrowserService from 'src/utils/browser.service';
import axios from 'axios';
import _ from 'lodash';
import { SketchPicker } from 'react-color';
import { localizedStrings } from 'src/localization/index.jsx';

class BannerImageEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      src: null,
      show: this.props.show,
      showBannerLibrary: false,
      showCropEditor: false,
      imageLoading: false,
      backgroundUpdated: false,
      canCrop: false,
      crop: {
        x: 0,
        y: 0,
        width: 100,
        height: 100,
        unit: "%"
      },
      sharedByEnabled: true,
      position: 'center center',
      mediaType: this.props.value.mediaType,
      width: this.props.width,
      height: this.props.height,
      filter: null,
      overlayColor: _.get(this.props.value, 'overlayColor') || 'rgba(0,0,0,0)',
      fontColor: _.get(this.props.value, 'fontColor') || 'rgba(0,0,0,1)',
      displayColorPalette: false,
      pexelsQuery: "",
      mediaSourceType: "",
      libraryType: "",
    }

    this.handleCropClicked = this.handleCropClicked.bind(this);
    this.onCropChange = this.onCropChange.bind(this);
    this.handleAddBannerClicked = this.handleAddBannerClicked.bind(this);
    this.handleBackgroundChange = this.handleBackgroundChange.bind(this);

    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleSharedByClicked = this.handleSharedByClicked.bind(this);

    this.onResetClick = this.onResetClick.bind(this);
    this.onUploadClick = this.onUploadClick.bind(this);
    this.handlePositionChange = this.handlePositionChange.bind(this);
    this.handleFontButtonOutsideClicked = this.handleFontButtonOutsideClicked.bind(this);
    this.handleMediaSwitch = this.handleMediaSwitch.bind(this);

    // localized contents
    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonLoading = localizedStrings.commons.loading;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizedAddBanner = localizedStrings.components.addBanner;
  }

  handleMediaSwitch(libraryType, mediaType, query) {
    this.setState({
      pexelsQuery: query,
      mediaSourceType: mediaType,
      libraryType: libraryType
    })
  }

  handleColorChange = (overlayColor) => {
    this.setState({
      overlayColor: overlayColor.rgb
    })
  };

  componentDidMount() {
    if (this.props.value && this.props.value.background && this.props.value.background.full) {
      this.loadImage(this.props.value.background.full).then(image => {
        var dataURL = this.getDataURL(image, this.state.crop);
        this.setState({
          src: dataURL,
          originalSrc: dataURL,
          position: this.props.value.position,
          filter: this.props.value.filter,
          overlayColor: this.props.value.overlayColor,
          fontColor: this.props.value.fontColor,
          sharedByEnabled: this.props.value.sharedByEnabled,
          imageLoading: false,
          mediaType: this.props.value.background.type
        })
      })
    }
    window.addEventListener('mousedown', this.handleFontButtonOutsideClicked);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.show != this.props.show) {
      var background = nextProps.value.background;
      if (background && background.full) {
        background = background.full;
      }
      background = background + "?=" + new Date().getTime()

      this.loadImage(background).then(image => {
        var dataURL = this.getDataURL(image, this.state.crop);
        this.setState({
          src: dataURL,
          originalSrc: dataURL,
          position: nextProps.value.position,
          filter: nextProps.value.filter,
          overlayColor: nextProps.value.overlayColor,
          fontColor: nextProps.value.fontColor,
          sharedByEnabled: nextProps.value.sharedByEnabled,
          canCrop: nextProps.value.mediaType === "image" ? true : false,
          imageLoading: false,
          backgroundUpdated: false,
          mediaType: nextProps.value.mediaType
        })
      }).catch(() => {
        this.setState({
          src: background,
          originalSrc: background,
          position: nextProps.value.position,
          filter: nextProps.value.filter,
          overlayColor: nextProps.value.overlayColor,
          fontColor: nextProps.value.fontColor,
          sharedByEnabled: nextProps.value.sharedByEnabled,
          canCrop: false,
          imageLoading: false,
          backgroundUpdated: false,
          mediaType: nextProps.value.mediaType
        })
      })

      this.setState({ show: nextProps.show });
    }

    if (!isEqual(this.props.value, nextProps.value)) {
      var background = nextProps.value.background;
      if (background && background.full) {
        background = background.full;
      }

      background = background + "?=" + new Date().getTime()

      this.loadImage(background).then(image => {
        var dataURL = this.getDataURL(image, this.state.crop);
        this.setState({
          src: dataURL,
          originalSrc: dataURL,
          position: nextProps.value.position,
          filter: nextProps.value.filter,
          overlayColor: nextProps.value.overlayColor,
          canCrop: nextProps.value.mediaType === "image" ? true : false,
          imageLoading: false,
          backgroundUpdated: true,
          mediaType: nextProps.value.mediaType
        })
      }).catch(() => {
        this.setState({
          src: background,
          originalSrc: background,
          position: nextProps.value.position,
          filter: nextProps.value.filter,
          overlayColor: nextProps.value.overlayColor,
          sharedByEnabled: nextProps.value.sharedByEnabled,
          canCrop: false,
          imageLoading: false,
          backgroundUpdated: false,
          mediaType: nextProps.value.mediaType
        })
      })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('mousedown', this.handleFontButtonOutsideClicked);
  }

  onUploadClick() {

    var request = {
      filter: this.state.filter,
      sharedByEnabled: this.state.sharedByEnabled,
      position: this.state.position,
      mediaType: this.state.mediaType,
      overlayColor: this.state.overlayColor,
      fontColor: this.state.fontColor
    };

    if (this.state.backgroundUpdated) {
      request['background'] = this.state.src;
    }

    if (this.props.onChange) {
      this.props.onChange(request);
    }

    if (this.props.updateGroupThumbnail) {
      request['background'] = this.state.src;

      this.props.updateGroupThumbnail(request, this.state.src);
    }

    var bannerType = _.get(this.state, "mediaType");
    var collectionName = _.get(this.props, "folio.name");
    var cta = _.get(this.props, "source", "");
    var collection = cta === "Collection" ? collectionName : "";

    this.props.trackAdoptionMetricsForBannerAddedCollectionEvent(collection, _.capitalize(bannerType), _.capitalize(cta));
  }

  onResetClick() {
    this.setState({
      filter: null,
      sharedByEnabled: false,
      src: null
    });

    if (this.props.onCancel) {
      this.props.onCancel();
    }
  }

  handleAddBannerClicked() {
    this.setState({
      showBannerLibrary: true
    })

    var cta = _.get(this.props, "source", "");
    const folioName = _.get(this.props, "folio.collection") ? _.get(this.props, "folio.collection.name") : _.get(this.props, 'folio.name');
    var folio = cta === "Collection" ? folioName : "";

    this.props.trackAdoptionMetricsForAddBannerForCollectionClickedEvent(_.capitalize(cta), folio);

  }

  handleBackgroundChange(data) {
    this.setState({
      showBannerLibrary: false,
      imageLoading: true,
      crop: {
        x: 0,
        y: 0,
        width: 100,
        height: 100,
        unit: "%"
      },
    });

    var mediaType = "image";
    var file = null;

    if (data.type === 'file') {
      file = data.file;

      if (file.type.match('image.*')) {
        mediaType = "image";
      } else if (file.type.match('video.*')) {
        mediaType = "video";
      }
    } else if (data.type === 'library') {
      file = data.item.imageUrl;
      mediaType = data.item.mediaType
    }

    if (mediaType === 'image') {
      this.loadImage(file).then(file => {
        var dataURL = this.getDataURL(file, this.state.crop);

        this.setState({
          src: dataURL,
          originalSrc: dataURL,
          imageLoading: false,
          backgroundUpdated: true,
          mediaType: 'image',
          canCrop: true,
        })
      }).catch(() => {
        this.setState({
          canCrop: false,
          imageLoading: false,
          backgroundUpdated: false
        })
      })
    } else if (mediaType === 'video') {
      if (typeof file === 'string') {
        this.loadVideoUrl(file).then(data => {
          const dataUrl = `data:video/mp4;base64,${data}`;

          this.setState({
            src: dataUrl,
            originalSrc: dataUrl,
            imageLoading: false,
            backgroundUpdated: true,
            mediaType: 'video',
            canCrop: false
          });
        });
      } else {
        this.loadImageFile(file).then(url => {
          var dataURL = url;

          this.setState({
            src: dataURL,
            originalSrc: dataURL,
            imageLoading: false,
            backgroundUpdated: true,
            mediaType: 'video',
            canCrop: false
          });
        });
      }

    }
  }

  handleCropClicked() {

    var bannerType = _.get(this.state, "mediaType");
    var cta = _.get(this.props, "source", "");

    const folioName = _.get(this.props, 'folio.name');
    var folio = cta === "Collection" ? folioName : "";

    this.props.trackAdoptionMetricsForCropBannerClickedCollectionEvent(folio, _.capitalize(bannerType), _.capitalize(cta));
    this.setState({
      showCropEditor: true
    })

  }

  onCropChange(crop) {
    this.loadImage(this.state.originalSrc).then(image => {
      var dataURL = this.getDataURL(image, crop);
      this.setState({
        src: dataURL,
        crop: crop,
        imageLoading: false,
        showCropEditor: false,
        backgroundUpdated: true
      })
    });
  }

  handleSharedByClicked() {
    this.setState({
      sharedByEnabled: !this.state.sharedByEnabled
    });
  }

  handlePositionChange(position) {
    this.setState({
      position: position
    });
  }

  handleFilterChange(value) {
    this.setState({
      ...value
    })
  }

  isDataURL(str) {
    if (str === null) {
      return false
    }
    const regex = /^\s*data:([a-z]+\/[a-z]+(;[a-z-]+=[a-z-]+)?)?(;base64)?,[a-z0-9!$&',()*+;=\-._~:@/?%\s]*\s*$/i
    return !!str.match(regex)
  }

  getDataURL(image, crop) {
    var canvas = document.createElement("canvas");
    var width = image.width;
    var height = image.height;

    if (image.width > 2650) {
      var resizedCanvas = this.resizeImage(image, 2650);
      image = resizedCanvas;
      width = resizedCanvas.width;
      height = resizedCanvas.height;
    }

    var sx = (width * crop.x) / 100;
    var sy = (height * crop.y) / 100;
    var sWidth = (width * crop.width) / 100;
    var sHeight = (height * crop.height) / 100;
    var aspectRatio = sWidth / sHeight;

    canvas.width = sWidth;
    canvas.height = sHeight;

    var ctx = canvas.getContext("2d");
    ctx.drawImage(image, sx, sy, sWidth, sHeight, 0, 0, sWidth, sHeight);

    return canvas.toDataURL("image/jpeg", 0.8);
  }

  resizeImage(image, width) {
    const canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");

    var scaleX = image.width / width;

    var dimension = {
      width: Math.floor(image.width * 0.5),
      height: Math.floor(image.height * 0.5)
    }

    canvas.width = dimension.width;
    canvas.height = dimension.height;
    ctx.drawImage(image, 0, 0);

    while (canvas.width * 0.5 > width) {
      dimension = {
        width: Math.floor(dimension.width * 0.5),
        height: Math.floor(dimension.height * 0.5)
      };

      ctx.drawImage(canvas, 0, 0, dimension.width * 2, dimension.height * 2, 0, 0, dimension.width, dimension.height);
    }

    canvas.width = width;
    canvas.height = canvas.width * image.height / image.width;
    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

    return canvas;
  }

  loadImage(image) {
    if (typeof File !== 'undefined' && image instanceof File) {
      return this.loadImageFile(image).then(url => {
        return this.loadImageURL(url)
      });
    } else if (typeof image === 'string') {
      return this.loadImageURL(image);
    }
  }

  loadImageURL(imageURL) {
    return new Promise((resolve, reject) => {
      const image = new Image()
      image.onload = () => resolve(image)
      image.onerror = reject
      if (this.isDataURL(imageURL) === false) {
        image.crossOrigin = 'anonymous'
      }

      image.src = imageURL
    })
  }

  loadImageFile(imageFile) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = e => resolve(e.target.result)
      reader.onerror = reject
      reader.readAsDataURL(imageFile)
    });
  }

  loadVideoUrl(videoUrl) {
    return axios.get(videoUrl, {
      responseType: 'arraybuffer'
    }).then(response => Buffer.from(response.data, 'binary').toString('base64'));
  }

  handleFontButtonOutsideClicked(e) {
    if (this.fontButtton && !this.fontButtton.contains(e.target)) {
      this.setState({
        displayColorPalette: false
      })
    }
  }

  render() {
    return (
      <div>
        <Modal show={this.state.show && !this.state.addNewBanner}
          keyboard={true}
          backdrop={true}
          dialogClassName={cx(styles.dialog, this.props.className)}
        >
          <Modal.Body className={cx(styles.modalBody)} >
            {this.renderImageView()}
            {this.state.showCropEditor &&
              <CropImageView src={this.state.originalSrc}
                crop={this.state.crop}
                collectionName={_.get(this.props, "folio.name", '')}
                entity={this.props.entity}
                source={_.get(this.props, "source")}
                dimension={this.props.dimension}
                onCrop={this.onCropChange}
                onCancel={() => {
                  this.setState({
                    showCropEditor: false
                  })
                }}
              />
            }

            {this.renderImageLibrary()}
          </Modal.Body>
        </Modal>
      </div>
    );
  }

  renderToolbar() {

    return (
      <ToolBar>
        <ToolBarGroup direction="left">
          <ToolBarButtonItem
            className={cx(styles.action)}
            width="auto" height="auto"
            onClick={this.handleAddBannerClicked}>
            <span className={styles.actionButton}><span className={cx("paperflite-image", styles.icon)}></span>{this.localizedAddBanner.add_banner.title}</span>
          </ToolBarButtonItem>
          {this.state.canCrop &&
            <ToolBarButtonItem
              className={cx(styles.action)}
              width="auto" height="auto"
              onClick={this.handleCropClicked}>
              <span className={styles.actionButton}><span className={cx("paperflite-crop", styles.icon)}></span>{this.localizedAddBanner.actions.crop}</span>
            </ToolBarButtonItem>
          }
          {this.props.entity === 'collection' &&
            <FilterDropdown value={this.state} trackAdoptionMetricsForFilterBannerClickedEvent={this.props.trackAdoptionMetricsForFilterBannerClickedEvent} trackAdoptionMetricsForBannerFilteredEvent={this.props.trackAdoptionMetricsForBannerFilteredEvent} folio={this.props.folio} bannerType={this.state.mediaType} onChange={this.handleFilterChange} />
          }
          {this.props.entity != 'group' &&

            <Dropdown>
              <Dropdown.Toggle className={styles.positionDropdown} as={'button'}>
                <span className={styles.position}> <i className={"paperflite-categories"} /> Position </span>
              </Dropdown.Toggle>
              <Dropdown.Menu className={styles.dropdown} popperConfig={{
                modifiers: [
                  {
                    name: 'offset',
                    options: {
                      offset: [0, 6],
                    },
                  },
                ],
              }}>
                <PositionView value={this.state.position} onChange={this.handlePositionChange} />

              </Dropdown.Menu>
            </Dropdown>}
          {this.props.entity === 'collection' &&
            <ToolBarButtonItem
              className={cx(styles.action, styles.sharedBy)}
              width="auto" height="auto"
              onClick={this.handleSharedByClicked}>
              <span className={styles.actionButton}>
                <span className={cx(!this.state.sharedByEnabled ? "fa fa-toggle-off" : "fa fa-toggle-on", styles.icon)}></span>{this.localizedAddBanner.actions.show_shared_by}
              </span>
            </ToolBarButtonItem>
          }
        </ToolBarGroup>
      </ToolBar>
    );
  }

  renderImageView() {
    if (this.state.showCropEditor || this.state.showBannerLibrary) {
      return false;
    }

    var style = {
      width: this.props.dimension.width,
      height: this.props.dimension.height
    }

    return (
      <div className={cx(styles.editor)}>
        {this.renderToolbar()}

        <div className={styles.inner} style={style}>
          {this.state.imageLoading &&
            <div className={styles.loading}>{this.localizedCommonLoading.loading}...</div>
          }

          {!this.state.imageLoading && this.state.mediaType === "image" &&
            this.renderImage()
          }

          {!this.state.imageLoading && this.state.mediaType === "video" &&
            this.renderVideo()
          }
        </div>
 
        <div className={styles.footer}>
            <Button
              variant="primary"
              icon="paperflite-tick"
              text={this.localizedCommonActions.upload}
              onClick={this.onUploadClick}
            />
            <Button
              variant="secondary"
              text="Cancel"
              onClick={() => { this.onResetClick() }}
            />
          </div> 
      </div>
    );
  }

  renderImageLibrary() {
    if (this.state.showCropEditor || !this.state.showBannerLibrary) {
      return false;
    }

    return (
      <div className={styles.library}>
        <ImageLibraryContainer
          type={this.props.entity}
          onChange={this.handleBackgroundChange}
          onCancel={() => {
            this.setState({
              showBannerLibrary: false
            })
          }}
          handleMediaSwitch={this.handleMediaSwitch}
          pexelsQuery={this.state.pexelsQuery}
          libraryType={this.state.libraryType}
          mediaType={this.state.mediaSourceType}
          folio={_.get(this.props, "folio")}
          source={_.get(this.props, "source")}
        />
      </div>
    );
  }

  renderImage() {

    var backgroundColor;
    var filter = this.state.filter;
    var gradient = false;

    switch (filter) {
      case 'gradientTop':
        backgroundColor = this.state.overlayColor ? `linear-gradient(-24.8312deg, rgba(255,255,255,0), rgba(${this.state.overlayColor.r}, ${this.state.overlayColor.g}, ${this.state.overlayColor.b}, ${this.state.overlayColor.a}))` : ``;
        gradient = true;
        break;
      case 'gradientBottom':
        backgroundColor = this.state.overlayColor ? `linear-gradient(135.862deg, rgba(255,255,255,0), rgba(${this.state.overlayColor.r}, ${this.state.overlayColor.g}, ${this.state.overlayColor.b}, ${this.state.overlayColor.a}))` : ``;
        gradient = true;
        break;
      case 'lines':
      case 'stripes':
      case 'dots':
        backgroundColor = this.state.overlayColor ? `rgba(${this.state.overlayColor.r}, ${this.state.overlayColor.g}, ${this.state.overlayColor.b}, ${this.state.overlayColor.a})` : ``;
        gradient = false;
        break;
      default:
        break;
    }

    var style = {
      'backgroundImage': `url("${this.state.src}")`,
      'backgroundPosition': `${this.state.position}`,
    };

    if (!gradient) {
      var overlay = {
        'backgroundColor': backgroundColor
      }
    }

    if (backgroundColor && gradient) {
      style.backgroundImage = `${backgroundColor}, url("${this.state.src}")`
    }

    return (
      <div className={styles.top} style={style}>
        {this.state.filter &&
          <div className={cx(styles.overlay, styles[this.state.filter])} style={overlay} />
        }

        {this.renderSharedBy()}
      </div>
    );
  }

  renderVideo() {
    var style = {
      'object-position': `${this.state.position}`,
    };

    var backgroundProperties = {
      'backgroundImage': '',
      'backgroundColor': ''
    };

    var filter = this.state.filter;

    switch (filter) {
      case 'gradientTop':
        backgroundProperties.backgroundImage = this.state.overlayColor ? `linear-gradient(-24.8312deg, rgba(255,255,255,0), rgba(${this.state.overlayColor.r}, ${this.state.overlayColor.g}, ${this.state.overlayColor.b}, ${this.state.overlayColor.a}))` : ``;
        break;
      case 'gradientBottom':
        backgroundProperties.backgroundImage = this.state.overlayColor ? `linear-gradient(135.862deg, rgba(255,255,255,0), rgba(${this.state.overlayColor.r}, ${this.state.overlayColor.g}, ${this.state.overlayColor.b}, ${this.state.overlayColor.a}))` : ``;
        break;
      case 'lines':
      case 'stripes':
      case 'dots':
        backgroundProperties.backgroundImage = '';
        backgroundProperties.backgroundColor = this.state.overlayColor ? `rgba(${this.state.overlayColor.r}, ${this.state.overlayColor.g}, ${this.state.overlayColor.b}, ${this.state.overlayColor.a})` : ``;
        break;
      default:
        backgroundProperties.backgroundImage = '';
        backgroundProperties.backgroundColor = '';
    }

    return (
      <div className={styles.top}>
        {this.state.filter &&
          <div className={cx(styles.overlay, styles[this.state.filter])} style={backgroundProperties} />
        }

        {BrowserService.getCurrentBrowser() == 'safari' ?
          <video height="auto" width="100%" autoPlay muted loop playsInline style={style}>
            <source src={this.state.src} type="video/mp4" />
          </video> :

          <video height="auto" width="100%" autoPlay muted loop style={style} src={this.state.src}></video>
        }

        {this.state.sharedByEnabled && this.renderSharedBy()}
      </div>
    );
  }

  renderSharedBy() {
    const fontColor = _.get(this.state, 'fontColor');

    const handleColorChange = (color) => {
      this.setState({
        fontColor: color.rgb
      })
    }
    return (
      <div>
        {this.state.sharedByEnabled &&
          <div className={styles.sharedByContainer} ref={(element) => {
            this.fontButtton = element
          }}>

            <SharedByView
              user={this.props.user}
              fontColor={fontColor}
              className={cx(styles.sharedBy, {
                [styles.visible]: this.state.sharedByEnabled
              })}
            />

            <button className={styles.edit}
              onClick={() => {
                this.setState({
                  displayColorPalette: true
                })
              }
              }>{this.localizedCommonActions.edit}</button>
            {this.state.displayColorPalette &&
              <ColorPicker className={styles.fontColorPicker}
                value={fontColor}
                onChange={handleColorChange}
                onClose={() => {
                  this.setState({
                    displayColorPalette: false
                  })
                }}
              />
            }

          </div>
        }
      </div>
    );
  }

}

class FilterDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dropDown: false,
      displayColorPalette: false
    }

    this.handleOverlayColorChange = this.handleOverlayColorChange.bind(this);
    this.handleFilterChoose = this.handleFilterChoose.bind(this);
    this._forceOpen = false;

    // localized contents
    this.localizedAddBanner = localizedStrings.components.addBanner;
  }

  dropdownToggle(newValue) {
    if (this._forceOpen) {
      this.setState({ dropDown: true });
      this._forceOpen = false;
    } else {
      this.setState({
        dropDown: newValue,
        displayColorPalette: false
      });
    }
  }

  preventDropDownClose() {
    this._forceOpen = true;
  }

  handleChange(value) {

    var collectioName = _.get(this.props, "folio.name");
    var cta = _.get(this.props, "folio.entityType");
    var bannerType = _.get(this.props, "bannerType");
    this.props.trackAdoptionMetricsForBannerFilteredEvent(collectioName, _.capitalize(bannerType), _.capitalize(cta));
    this.props.onChange(value);
  }
  handleFilterChoose() {

    var collectioName = _.get(this.props, "folio.name");
    var cta = _.get(this.props, "folio.entityType");
    var bannerType = _.get(this.props, "bannerType");

    this.props.trackAdoptionMetricsForFilterBannerClickedEvent(collectioName, _.capitalize(bannerType), _.capitalize(cta));

  }

  handleOverlayColorChange(color, event) {
    this.props.onChange({
      overlayColor: color.rgb
    });
  }

  getColor(value) {
    const r = _.get(value, 'r', 0);
    const g = _.get(value, 'g', 0);
    const b = _.get(value, 'b', 0);
    const a = _.get(value, 'a', 0);

    return `rgba(${r}, ${g}, ${b}, ${a})`
  }

  isFromDealRoom() {
    return _.get(this.props, "folio.viewerType") === "DEAL_ROOM" ? true : false;
  }

  render() {
    const filter = _.get(this.props, 'value.filter');
    const overlayColor = _.get(this.props, 'value.overlayColor');

    return (
      <Dropdown>
      <Dropdown.Toggle className={styles.filterDropdownContainer} as="button">
        <span className={styles.actionButton} onClick={this.handleFilterChoose}>
          <i className={cx("paperflite-filter", styles.icon)} />
          <span className={styles.iconText}>{this.localizedAddBanner.actions.filter}</span>
        </span>
      </Dropdown.Toggle>
      <Dropdown.Menu
        className={cx(styles.filterDropDown)}
        popperConfig={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 6],
              },
            },
          ],
        }}
      >
        {[
          { filterValue: null, icon: noFilterIcon },
          { filterValue: 'dark', icon: darkFilter },
          { filterValue: 'light', icon: lightFilter },
          { filterValue: 'dots', icon: dots, overlayColor: { r: '0', g: '0', b: '0', a: '0.5' } },
          { filterValue: 'lines', icon: lines, overlayColor: { r: '0', g: '0', b: '0', a: '0.5' } },
          { filterValue: 'stripes', icon: stripes, overlayColor: { r: '0', g: '0', b: '0', a: '0.5' } },
          { filterValue: 'gradientTop', icon: gradientTop, overlayColor: { r: '0', g: '0', b: '0', a: '1' } },
          { filterValue: 'gradientBottom', icon: gradientBottom, overlayColor: { r: '0', g: '0', b: '0', a: '1' } },
          { filterValue: 'darkOverlay', icon: darkOverlay },
          { filterValue: 'whiteOverlay', icon: whiteOverlay },
          { filterValue: 'frosted', icon: darkOverlay },
        ].map(({ filterValue, icon, overlayColor }, index) => (
          (!this.isFromDealRoom() || filterValue !== 'gradientTop' && filterValue !== 'gradientBottom') && (
            <div
              key={index}
              className={cx(styles.dropDownMenuItem, { [styles.active]: filter === filterValue })}
              onClick={() => {
                this.preventDropDownClose();
                this.handleChange({
                  filter: filterValue,
                  overlayColor: overlayColor || null,
                });
              }}
            >
              <div className={styles.toolbarItem}>
                <BootstrapImage src={icon} className={styles.filterIcon} />
              </div>
            </div>
          )
        ))}
    
        {overlayColor && (
          <div className={styles.overlay}>
            <span className={styles.filterText}>{this.localizedAddBanner.actions.color}</span>
            <div
              className={styles.colorSwatch}
              style={{ backgroundColor: this.getColor(overlayColor) }}
              onClick={() => this.setState({ displayColorPalette: true })}
            />
          </div>
        )}
    
        {this.state.displayColorPalette && (
          <ColorPicker
            className={styles.overlayColorPicker}
            value={overlayColor}
            onChange={this.handleOverlayColorChange}
            onClose={() => this.setState({ displayColorPalette: false })}
          />
        )}
      </Dropdown.Menu>
    </Dropdown>
    );
  }
}    
class ColorPicker extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleClose = this.handleClose.bind(this);

    // localized contents
    this.localizedAddBanner = localizedStrings.components.addBanner;
  }

  handleChange(color, event) {
    this.props.onChange(color, event);
  }

  handleClose() {
    this.props.onClose();
  }

  render() {
    return (
      <div className={cx(styles.colorPicker, this.props.className)}>
        <SketchPicker
          color={this.props.value}
          onChangeComplete={this.handleChange}
        />
        <button onClick={this.handleClose}>{this.localizedAddBanner.actions.done}</button>
      </div>
    );
  }
}

BannerImageEditor.defaultProps = {
  dimension: {
    width: 800,
    height: 400
  }
};



export default BannerImageEditor;